import { type Slot } from '@service-initiation/shared-clients-tech-care-services';

export const isSlotType = (slot: Slot | false | undefined): slot is Slot => {
  return slot !== false && slot !== undefined;
};
